import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 'calc(100% - 8px)',
    height: '50px',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    zIndex: 2,
  },
}));
